import { Button, Divider, Stack, Typography } from '@mui/material'
import {
  LoginConfigurationKind,
  useLoginConfigurationQuery,
} from 'src/generated/apollo'
import { isMobile, useTenantCode } from 'src/utils/chaos'
import { useIntl } from '@frontend/t7nd'

type DispatchLogin = {
  kind: LoginConfigurationKind
  authenticationConfigurationName?: string
  loginUrl?: string
}

export const SSOLoginMessages = {
  LOGIN_VIA_SYSTEM: {
    id: '通过系统登录',
    defaultMessage: '通过系统登录',
  },
  QUICK_LOGIN: {
    id: '快捷登录，无需账号密码',
    defaultMessage: '快捷登录，无需账号密码',
  },
  ONE_CLICK_LOGIN: {
    id: '一键登录',
    defaultMessage: '一键登录',
  },
} as const

export function SSOLogin() {
  const { formatMessage } = useIntl()
  const mobile = isMobile()
  const tenantCode = useTenantCode()
  const { data, refetch } = useLoginConfigurationQuery({
    variables: { tenantCode },
    skip: !tenantCode,
  })

  return (
    <Stack sx={{ opacity: data?.loginConfiguration ? 1 : 0 }}>
      <Stack justifyContent="center" height={mobile ? 284 : 280}>
        <Stack
          sx={{
            width: '100%',
            p: mobile ? 0 : '48px 36px',
            borderRadius: '8px',
            alignItems: 'center',
            boxShadow: mobile
              ? undefined
              : ' 0px 1px 10px rgba(26, 59, 164, 0.06), 0px 4px 5px rgba(26, 59, 164, 0.08);',
          }}
        >
          <Typography variant="h3">{`${formatMessage(
            SSOLoginMessages.LOGIN_VIA_SYSTEM,
          )}${
            ((data?.loginConfiguration ?? {}) as DispatchLogin)
              .authenticationConfigurationName
          }`}</Typography>
          <Divider
            sx={{
              width: '286px',
              margin: '8px',
            }}
          />
          <Typography variant="subtitle2" color="text.secondary">
            {formatMessage(SSOLoginMessages.QUICK_LOGIN)}
          </Typography>
        </Stack>
      </Stack>
      <Button
        fullWidth
        size={mobile ? 'medium' : 'large'}
        onClick={async () => {
          const { data } = await refetch()
          window.open(
            (data.loginConfiguration as DispatchLogin)?.loginUrl,
            '_self',
          )
        }}
      >
        {formatMessage(SSOLoginMessages.ONE_CLICK_LOGIN)}
      </Button>
    </Stack>
  )
}
